import { ENTER_URL, SITE } from "../brand/config";

export type ShellEls = {
  root: HTMLElement;
  canvas: HTMLCanvasElement;
  leafCanvas: HTMLCanvasElement;
  track: HTMLElement;
  brandLine: HTMLElement;
  chapterLabel: HTMLElement;
  chapterLearn: HTMLElement;
  progressEl: HTMLElement;
  enter: HTMLAnchorElement;
  loader: HTMLElement;
  loaderPct: HTMLElement;
  tierPill: HTMLElement;
  hud: HTMLElement;
};

export function mountAnteroomShell(app: HTMLElement): ShellEls {
  app.innerHTML = `
    <div class="loader" data-loader>
      <span class="loader-pct" data-loader-pct>00%</span>
    </div>
    <div class="tier-pill" data-tier></div>
    <div class="leaf-fractal-stage" aria-hidden="true">
      <canvas data-leaf-canvas></canvas>
    </div>
    <div class="stage">
      <canvas data-canvas aria-hidden="true"></canvas>
    </div>
    <div class="scroll-track" data-track aria-hidden="true"></div>
    <div class="hud" data-hud>
      <header class="brand">
        <h1 class="brand-mark">${SITE.name}</h1>
        <p class="brand-line" data-brand-line>${SITE.promise}</p>
      </header>
      <div class="chapter-meta">
        <span class="chapter-label" data-chapter-label>Arrival</span>
        <p class="chapter-learn" data-chapter-learn>${SITE.tagline}</p>
      </div>
      <div class="footer-bar">
        <span class="progress" data-progress>000</span>
        <a class="enter" data-enter href="${ENTER_URL}">ENTER</a>
      </div>
    </div>
  `;

  return bindShell(app);
}

function bindShell(app: HTMLElement): ShellEls {
  return {
    root: app,
    canvas: app.querySelector("[data-canvas]") as HTMLCanvasElement,
    leafCanvas: app.querySelector("[data-leaf-canvas]") as HTMLCanvasElement,
    track: app.querySelector("[data-track]") as HTMLElement,
    brandLine: app.querySelector("[data-brand-line]") as HTMLElement,
    chapterLabel: app.querySelector("[data-chapter-label]") as HTMLElement,
    chapterLearn: app.querySelector("[data-chapter-learn]") as HTMLElement,
    progressEl: app.querySelector("[data-progress]") as HTMLElement,
    enter: app.querySelector("[data-enter]") as HTMLAnchorElement,
    loader: app.querySelector("[data-loader]") as HTMLElement,
    loaderPct: app.querySelector("[data-loader-pct]") as HTMLElement,
    tierPill: app.querySelector("[data-tier]") as HTMLElement,
    hud: app.querySelector("[data-hud]") as HTMLElement,
  };
}
